import React from 'react';

import { faList } from '@fortawesome/free-solid-svg-icons';
import { core } from 'core';
import { Kit } from 'ui/Kit';

interface Props {}

export const ProjectsMenu: React.FC<Props> = () => {
  return (
    <Kit.NavMenu>
      <Kit.NavItem
        to={core.toPage('/list')}
        icon={faList}
        text={'Project list'}
      />
      <Kit.NavItem
        to={core.toPage('/manage/messages')}
        icon={faList}
        text={'Managing messages'}
      />
    </Kit.NavMenu>
  );
};
